import React, { useEffect, useCallback, useState, useContext } from 'react'
import { API } from 'api/API';
import { Table, Card, Button, Alert, Spinner, Tooltip, OverlayTrigger, Row, Col } from 'react-bootstrap';
import { RECURRINGPAYMENTS_URL, BUSINESS_DONATION_CAUSES } from 'config/config';
import { extractError } from 'api/ErrorUtil';
import _ from "lodash";
import { SecurityContext } from '../../security/SecurityContext';
import { TenantContext } from '../../tenant/TenantContext';
import { formatDate, stringUTCToLocal } from 'util/Date';
import { formatCurrency } from 'util/Currency';
import { evenRound } from 'util/NumberUtils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faDollar, faEdit, faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { useNavigate } from 'react-router-dom';
import { NewButton } from 'uiwidgets/NewButton';
import { PAGE_SIZE } from 'config/config';
import { stringToDateBeginningOfDayUTC } from 'util/Date';
import { stringToDateEndOfDayUTC } from 'util/Date';
import { FormContainer } from 'uiwidgets/FormContainer';
import { FormField } from 'uiwidgets/FormField';
import { containsAlphaNumAndSpaceOnly, isValidDate } from 'util/Validators';


const RecurringPaymentListPage = () => {

    const initialFilterDate = {
        keyword: "",
        fromPaymentDate: "",
        toPaymentDate: ""
    }

    const initialFilterValidityData = {
        keywordError: false,
        keywordErrMsg: "",
        fromPaymentDateError: false,
        fromPaymentDateErrMsg: "",
        toPaymentDateError: false,
        toPaymentDateErrMsg: ""
    }

    const initialFormData = { donationCauses: [], keyword: "", fromPaymentDate: "", toPaymentDate: "", errors: {} };
    const [formData, setFormData] = useState(initialFormData);
    const secCtx = useContext(SecurityContext);
    const { businessConfig } = useContext(TenantContext);
    const [currentPage, setCurrentPage] = useState(0)
    const [totalNumberOfPages, setTotalNumberOfPages] = useState(0);
    const [filterData, setFilterData] = useState(initialFilterDate);
    const [filterValidityData, setFilterValidityData] = useState(initialFilterValidityData);
    const navigate = useNavigate();

    const onToastClose = () => {
        setFormData({ ...formData, errors: {}, infoMessage: "" });
    }

    const getDonationCauseDescriptionById = (causeId) => {
        let donationCauses = formData.donationCauses.filter(dc => dc.id == causeId);
        if (!_.isEmpty(donationCauses)){
            return donationCauses[0].donationCauseDescription;
        }
        return "";
    }
   
    const getAccountTypeById = (accountTypeId) => {
        let filteredAccountTypes = formData.accountTypes.filter(accType => accountTypeId === accType.id);
        return filteredAccountTypes[0];
    }

    const getRecurringPaymentSpecs = async (params) => {
        let rcrPmtsSpecResp = await API.get(RECURRINGPAYMENTS_URL, {
            params: params
        });
        return rcrPmtsSpecResp.data;
    }

    const fetchRecurringPaymentSpecsForce = useCallback(async () => {
        console.log("fetch recurring payment specs force");
        try {
            let rcrPmtsSpecResp = await getRecurringPaymentSpecs({ page: currentPage, size: PAGE_SIZE });
            setFormData({
                ...formData,
                rcrPmtsSpecs: rcrPmtsSpecResp.content
            });
            setTotalNumberOfPages(rcrPmtsSpecResp.totalPages);
            setCurrentPage(0);
            setFilterData(initialFilterDate);
            setFilterValidityData(initialFilterValidityData);
        } catch (error) {
            console.log("Error when fetching recurring payments", error)
            let exError = extractError(error);
            if (exError.httpStatus === 404) {
                setFormData({
                    ...formData,
                    rcrPmtsSpecs: [],
                    infoMessage: "No Recurring payments were found"
                });
            } else {
                setFormData({
                    ...formData,
                    errors: exError
                });
            }
        }

    });

    const fetchDonationCauses = async () => {
        let donationCauses = [];
        try {
            console.log("Fetching donation causes");
            if (businessConfig.appFeatures.includes('DONATION_MANAGEMENT')) {
                donationCauses = formData.donationCauses;
                if (_.isEmpty(formData.donationCauses)) {
                    let resp = await API.get(BUSINESS_DONATION_CAUSES);
                    donationCauses = resp.data;
                }
                return donationCauses;
            }
        } catch (error) {
            console.log("Error when fetching donation causes", error)
            let exError = extractError(error);
            if (exError.httpStatus === 404) {
                console.log("Donation causes were not found");
            } else {
                setFormData({
                    ...formData,
                    errors: exError
                });
            }
        }
    };

    const fetchRecurringPaymentSpecs = useCallback(async () => {

        let lFormData = {...formData,accountTypes: businessConfig.accountTypes,};
        try {
            //get donation causes
            let donationCauses = await fetchDonationCauses();
            lFormData = {...lFormData,donationCauses: donationCauses }

            console.log("Fetching initial recurring payment specs");
            let rcrPmtsSpecResp = await getRecurringPaymentSpecs({
                page: currentPage, size: PAGE_SIZE, keyword: filterData.keyword.trim(),
                fromPaymentDate: filterData.fromPaymentDate ? stringToDateBeginningOfDayUTC(filterData.fromPaymentDate) : "",
                toPaymentDate: filterData.toPaymentDate ? stringToDateEndOfDayUTC(filterData.toPaymentDate) : ""
            });

            lFormData = {...lFormData,rcrPmtsSpecs: rcrPmtsSpecResp.content }
            setTotalNumberOfPages(rcrPmtsSpecResp.totalPages);
            setFormData(lFormData);

        } catch (error) {
            console.log("Error when fetching recurring payments", error)
            let exError = extractError(error);
            if (exError.httpStatus === 404) {
                setFormData({
                    ...lFormData,
                    rcrPmtsSpecs: [],
                    infoMessage: "No Recurring payments were found"
                });

            } else {
                setFormData({
                    ...lFormData,
                    errors: exError
                });
            }
        }
    });

    

    useEffect(() => {
        fetchRecurringPaymentSpecs();
    }, [currentPage]);

    useEffect(() => {
        if (filterData.keyword.length > 3) {
            console.log("Fetching recurring payments spec for filter grater than 3")
            fetchRecurringPaymentSpecs();
        }
    }, [filterData.keyword]);

    useEffect(() => {
        if (filterData.fromPaymentDate && filterData.toPaymentDate) {
            console.log("Fetching recurring payments spec for filter grater than 3")
            fetchRecurringPaymentSpecs();
        }
    }, [filterData.toPaymentDate, filterData.fromPaymentDate]);

    const deleteRecPmt = async (event, recPmtSpecId) => {
        try {
            await API.delete(RECURRINGPAYMENTS_URL + "/" + recPmtSpecId);
            let rcrPmtsSpecResp = await getRecurringPaymentSpecs({
                page: currentPage, size: PAGE_SIZE, keyword: filterData.keyword.trim(),
                fromPaymentDate: filterData.fromPaymentDate ? stringToDateBeginningOfDayUTC(filterData.fromPaymentDate) : "",
                toPaymentDate: filterData.toPaymentDate ? stringToDateEndOfDayUTC(filterData.toPaymentDate) : ""
            });
            setFormData({
                ...formData,
                rcrPmtsSpecs: rcrPmtsSpecResp.content,
                infoMessage: "Recurring Payment Schedule was successfully deleted"
            });
            setTotalNumberOfPages(rcrPmtsSpecResp.totalPages);
        } catch (error) {
            let exError = extractError(error);
            if (exError.httpStatus === 404) {
                setFormData({
                    ...formData,
                    rcrPmtsSpecs: [],
                    infoMessage: "No Recurring Payments were found"
                });

            } else {
                setFormData({
                    ...formData,
                    errors: exError
                });
            }
        }
    }
    const payRecPmt = async (event, recPmtSpecId) => {
        try {
            if (!window.confirm("Are you sure you want to make a one time payment")) {
                return false;
            }
            setFormData({
                ...formData,
                processing: recPmtSpecId,
                infoMessage: "",
                errors: {}

            });
            await API.post(RECURRINGPAYMENTS_URL + "/" + recPmtSpecId + "/actions/pay");
            let rcrPmtsSpecResp = await getRecurringPaymentSpecs({
                page: currentPage, size: PAGE_SIZE, keyword: filterData.keyword.trim(),
                fromPaymentDate: filterData.fromPaymentDate ? stringToDateBeginningOfDayUTC(filterData.fromPaymentDate) : "",
                toPaymentDate: filterData.toPaymentDate ? stringToDateEndOfDayUTC(filterData.toPaymentDate) : ""
            });
            setFormData({
                ...formData,
                rcrPmtsSpecs: rcrPmtsSpecResp.content,
                infoMessage: "One time recurring payment was successful"
            });
            setTotalNumberOfPages(rcrPmtsSpecResp.totalPages);
        } catch (error) {
            let exError = extractError(error);
            setFormData({
                ...formData,
                errors: exError,
                processing: null
            });
        }
    }
    const editRecPmt = async (event, recPmtSpec) => {
        if (secCtx.authState && secCtx.profile.roles.includes("ROLE_BUSINESS_ADMIN")) {
            navigate("/admin-edit-recurring-payments/" + recPmtSpec.id, { state: { recPmtSpec: recPmtSpec } });
        } else if (secCtx.authState && secCtx.profile.roles.includes("ROLE_CONSUMER")) {
            navigate("/edit-recurring-payments/" + recPmtSpec.id, { state: { recPmtSpec: recPmtSpec } });
        }
        return;
    }
    const handlePaging = async (page) => {
        if (page < 0) {
            alert("Reached the beginning of data set")
            page = 0;
        }
        if (page > totalNumberOfPages - 1) {
            alert("Reached the end of data set")
            page = totalNumberOfPages - 1;
        }
        setCurrentPage(page);
    }
    const handleFilterKeyDown = async (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            fetchRecurringPaymentSpecs();
        }
    };
    const clearFilter = async (event) => {
        fetchRecurringPaymentSpecsForce();
    };
    const handleChange = async (event) => {
        const name = event.target.name;
        const value = event.target.value;
        setFilterData({
            ...filterData,
            [name]: value
        })
    }

    const handleValidation = async (event) => {
        const name = event.target.name;
        const value = event.target.value;
        let { hasError, error } = validateInput(name, value);
        setFilterValidityData({
            ...filterValidityData,
            [name + 'Error']: hasError,
            [name + 'ErrMsg']: error
        })
    }

    const validateInput = (name, value) => {
        let hasError = false,
            error = ""
        switch (name) {
            case "keyword":
                if (value.trim() === "") {
                    hasError = false
                    error = ""
                } else if (!containsAlphaNumAndSpaceOnly(value)) {
                    hasError = true
                    error = "Invalid keyword. Only alphanumeric characters are allowed";
                } else {
                    hasError = false
                    error = ""
                }
                break
            case "fromPaymentDate":
                if (value.trim() === "") {
                    hasError = false;
                    error = "";
                } else if (!isValidDate(value)) {
                    hasError = true;
                    error = "From Payment Date is invalid"
                } else {
                    hasError = false;
                    error = "";
                }
                break;
            case "toPaymentDate":
                if (value.trim() === "") {
                    hasError = false;
                    error = "";
                } else if (!isValidDate(value)) {
                    hasError = true;
                    error = "To Payment Date is invalid"
                } else {
                    hasError = false;
                    error = "";
                }
                break;
            default:
                break;
        }
        return { hasError, error };
    }
    return (
        <>
            <FormContainer title="Recurring Payment Schedules" toastCloseFunc={onToastClose} errors={formData.errors} infoMessage={formData.infoMessage} >
                <Row>
                    <Col>

                        <NewButton label="Add New Recurring Payment Schedule" onClick={(event) => {
                            if (secCtx.authState && secCtx.profile.roles.includes("ROLE_BUSINESS_ADMIN")) {
                                navigate("/admin-add-recurring-payments/");
                            } else if (secCtx.authState && secCtx.profile.roles.includes("ROLE_CONSUMER")) {
                                navigate("/add-recurring-payments/");
                            }
                        }} />
                    </Col>
                </Row>
                <Row>
                    {secCtx.authState && secCtx.profile.roles.includes("ROLE_BUSINESS_ADMIN") &&
                        <Col sm={12} md={4} lg={4}>
                            <FormField name="keyword" label="Payer Email" type="text" value={filterData.keyword}
                                placeholder="payer email" onChange={handleChange}
                                onBlur={handleValidation} onKeyDown={handleFilterKeyDown}
                                valstate={!filterValidityData.keywordError} valMsg={filterValidityData.keywordErrMsg} />
                        </Col>}
                    <Col sm={6} md={2} lg={2}>
                        <FormField name="fromPaymentDate" label="From Payment Date" type="date" value={filterData.fromPaymentDate}
                            placeholder="Enter From Date" onChange={handleChange} onBlur={handleValidation}
                            valstate={!filterValidityData.fromPaymentDateError} valMsg={filterValidityData.fromPaymentDateErrMsg} />
                    </Col>
                    <Col sm={6} md={2} lg={2}>
                        <FormField name="toPaymentDate" label="To Payment Date" type="date" value={filterData.toPaymentDate}
                            placeholder="Enter To Date" onChange={handleChange} onBlur={handleValidation}
                            valstate={!filterValidityData.toPaymentDateError} valMsg={filterValidityData.toPaymentDateErrMsg} />
                    </Col>
                    <Col sm={6} md={2} lg={2}>
                        <br />
                        <Button variant="info" className="border-0 btn-fill" onClick={clearFilter}><strong><small>Clear Filter</small></strong></Button>
                    </Col>
                </Row>


                {!_.isEmpty(formData.rcrPmtsSpecs) &&
                    <React.Fragment>
                        <Row>
                            <Col className='d-flex justify-content-end'>
                                <Button variant="dark" className="border-0 text-dark" onClick={(event) => { handlePaging(currentPage - 1) }}>
                                    <h6><FontAwesomeIcon icon={faArrowLeft} />Previous Page</h6>
                                </Button>
                                &nbsp;<span className="border-0 text-dark btn"><h6>{currentPage + 1} of {totalNumberOfPages}</h6></span>
                                &nbsp;<Button variant="dark" className="border-0 text-dark" onClick={(event) => { handlePaging(currentPage + 1) }}>
                                    <h6>Next Page<FontAwesomeIcon icon={faArrowRight} /></h6>
                                </Button>
                            </Col>
                        </Row>
                    </React.Fragment>}
                <Table>
                    <thead>
                        <tr>
                            {secCtx.authState && secCtx.profile.roles.includes("ROLE_BUSINESS_ADMIN") &&
                                <th className="border-0">Email</th>}
                            <th className="border-0">Account Type</th>
                            <th className="border-0">Account Id</th>
                            <th className="border-0">Next Payment Date</th>
                            {(businessConfig.appFeatures.includes('BILLING')) &&
                                <th className="border-0">Pay Bill Amount</th>}
                            <th className="border-0">Payment Frequency</th>
                            <th className="border-0">Total Payment Amount</th>
                            <th className="border-0">Card</th>
                            <th className="border-0">Exp Date</th>
                            <th className="border-0">Detail</th>
                            <th className="border-0">Delete</th>
                            <th className="border-0">Edit</th>
                            {secCtx.authState && secCtx.profile.roles.includes("ROLE_CONSUMER") && <>
                                <th className="border-0">Pay</th></>}
                        </tr>
                    </thead>
                    <tbody>
                        {!_.isEmpty(formData.rcrPmtsSpecs) && formData.rcrPmtsSpecs.map((rcpPmtSpec, idx) => {
                            const disableDeleteButton = rcpPmtSpec.recurringPaymentSpecDetail.some(item => (!_.isEmpty(item.sponsorshipId)));
                            const accountType = getAccountTypeById(rcpPmtSpec.accountTypeId);
                            return (
                                <tr key={idx}>
                                    {secCtx.authState && secCtx.profile.roles.includes("ROLE_BUSINESS_ADMIN")
                                        && <td>{rcpPmtSpec.payer.email}</td>}
                                    <td>{accountType.accountTypeDisplayName}</td>
                                    <td>{rcpPmtSpec.accountNumber}</td>
                                    <td>{formatDate(stringUTCToLocal(rcpPmtSpec.nextPaymentDate))}</td>
                                    {(businessConfig.appFeatures.includes('BILLING')) &&
                                        <td> {accountType.accountType !== 'DONATION' && (rcpPmtSpec.payFullAmount ? "Yes" : "No")}
                                            {accountType.accountType === 'DONATION' && "N/A"}
                                        </td>}
                                    <td>{rcpPmtSpec.paymentFrequency}</td>
                                    <td>{formatCurrency(evenRound(parseFloat(rcpPmtSpec.paymentAmount)) / 100, businessConfig.locale, businessConfig.currency)}</td>
                                    <td>{rcpPmtSpec.paymentSourceType !== 'OFFLINE' ? rcpPmtSpec.maskedCardNumber : "n/a for offline payment"}</td>
                                    <td>{rcpPmtSpec.paymentSourceType !== 'OFFLINE' ? rcpPmtSpec.expDate : "n/a for offline payment"}</td>
                                    <td>
                                        {rcpPmtSpec.recurringPaymentSpecDetail.map((rpsd, idx2) => (
                                        <div key={idx2}>
                                            {getDonationCauseDescriptionById(rpsd.causeId)} <br />
                                        </div>
                                        ))}
                                    </td>

                                    <td align='center'>
                                        {!disableDeleteButton &&
                                            <Button variant="dark" className="border-0 text-dark" onClick={evt => deleteRecPmt(evt, rcpPmtSpec.id)}
                                                alt="hello">
                                                <FontAwesomeIcon icon={faTrash} title={disableDeleteButton ? "Disabled because Sponsorship is linked to the recurring payment" : "Click to delete the recurring payment specification"} />
                                            </Button>}
                                        {disableDeleteButton &&
                                            <FontAwesomeIcon icon={faTrash} color="grey"
                                                title={disableDeleteButton ? "Disabled because Sponsorship is linked to the recurring payment" : "Click to delete the recurring payment specification"} />}
                                    </td>
                                    <td align='center'>
                                        <Button variant="dark" className="border-0 text-dark" onClick={evt => editRecPmt(evt, rcpPmtSpec)}>
                                            <FontAwesomeIcon icon={faEdit} title='Edit Recurring Payment' />
                                        </Button>

                                    </td>
                                    {secCtx.authState && secCtx.profile.roles.includes("ROLE_CONSUMER") && <>
                                        <td align='center'>
                                            {formData.processing === rcpPmtSpec.id ? (
                                                <Spinner
                                                    style={{ marginBottom: 27 }}
                                                    animation="border"
                                                    variant="success"
                                                />) : (
                                                <Button variant="dark" className="border-0 text-dark" onClick={evt => payRecPmt(evt, rcpPmtSpec.id)}>
                                                    <FontAwesomeIcon icon={faDollar} title="Make a one time payment" />
                                                </Button>)}
                                        </td></>}
                                </tr>
                            )
                        }
                        )}
                    </tbody>
                </Table>
            </FormContainer>
        </>)
}

export default RecurringPaymentListPage